import React from 'react';
import PropTypes from 'prop-types';
import ProcessUtils from 'utils/ProcessUtils';

/**
 * Base class for process form field components that can be reused throughout the PCM.
 */
export default class ProcessField extends React.Component {

    static propTypes = {
        process: PropTypes.object,       // the process from the store
        processErrors: PropTypes.object, // the process validation errors
        hasWritePermissions: PropTypes.bool, // whether this field can be edited or not
        forceFormDisplay: PropTypes.bool, // whether the field should always render as a form field
        className: PropTypes.string,
        displayLabel: PropTypes.bool // whether
    };

    static defaultProps = {
        forceFormDisplay: false,
        hasWritePermissions: true,
        displayLabel: false
    };

    onFieldUpdated = (fieldPath, value) => {
        ProcessUtils.updateField(this.props.process, fieldPath, value);
    };
}



// WEBPACK FOOTER //
// ./src/components/core/fields/ProcessField.js